export default __webpack_public_path__ + "assets/images/vehicle_3btbw.jpg";